<!--
 * @Author: chenguanbin
 * @Date: 2020-01-13 21:03:47
 * @Desc: 企业超期未处置预警排名
 -->
<template>
  <ViewPanel title="企业超期未处置预警排名" scroll :active="active">
    <li v-for="(item, index) in rankList" :key="item.enterpriseName" class="compnay-item">
      <div class="rank">{{ index !== 0 ? index + 1 : '' }}</div>
      <div v-ellipsis class="compnay">{{ item.enterpriseName }}</div>
      <div class="rate">{{ item.number }}</div>
    </li>
    <div v-show="noData" class="no-data">
      暂无数据
    </div>
  </ViewPanel>
</template>

<script>
import ViewPanel from '../Components/ViewPanel'
import * as api from '@/api'
import utils from '@/utils'
export default {
  name: 'ExpiredWarnRanking',
  components: { ViewPanel },
  inject: ['$riskMonitor'],
  props: {
    geoData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      rankList: []
    }
  },
  computed: {
    active() {
      return this.$riskMonitor.activePanel.toLowerCase() === this.$options.name.toLowerCase()
    },
    /**  显示没有数据 */
    noData() {
      return this.rankList.length === 0
    }
  },
  watch: {
    geoData() {
      this.getData()
    }
  },
  methods: {
    /**
     * 查询超期未处置企业排名
     * @author zhubincong
     * @date 2020-03-16 17:22:40
     */
    async getData() {
      const { data } = await api.emmsRiskMonitorQueryOverdueEnterpriseRank({
        data: { projectCode: this.$store.state.projectCode, count: 5 }
      })
      // 随机生成区域内经纬度
      this.rankList = utils.getRandomPoint4List(data.list, this.geoData).map((n, i) => {
        n.label = `TOP ${i + 1}`
        return n
      })
    },
    /**
     * 渲染地图
     * @author zhubincong
     * @date 2020-03-11 18:47:37
     */
    renderMap() {
      const { mapChart, mapView } = this.$riskMonitor
      // 清除其他业务图表
      mapView.clear()
      if (this.rankList.length === 0) {
        mapChart.repaint()
        return
      }
      mapView.source(this.rankList)
      mapView
        .point()
        .position('longitude*latitude')
        .size(0)
        .tooltip('enterpriseName*number', (name, value) => ({ name, value }))
        .label('enterpriseName', {
          useHtml: true,
          htmlTemplate(name, { point }, index) {
            return `<div class="warn-compnay-map warn-compnay-map-${index}"><p style="color:black;padding-left: 40px;">${point.label}</p><p class="enterp-ellipsis">${name}</p></div>`
          },
          offset: 75
        })
      mapChart.legend(false)
      mapChart.repaint()
    },
    /**
     * 刷新数据
     * @author zhubincong
     * @date 2020-03-18 17:12:42
     */
    async refreshData() {
      await this.getData()
      if (this.active) this.renderMap()
    }
  }
}
</script>

<style lang="scss" scoped>
.compnay-item {
  height: 46px;
  background: url('~@/assets/images/RiskMonitoring/comp-item.png') no-repeat;
  background-size: 100% 100%;
  display: flex;
  align-items: center;
  padding-bottom: 6px;
  + .compnay-item {
    margin-top: 10px;
  }
}
.compnay-item:first-child {
  background: url('~@/assets/images/RiskMonitoring/copm-item-1.png') no-repeat;
  background-size: 100% 100%;
}
.rank {
  color: #ffffff;
  text-align: center;
}
.compnay {
  color: #8feeff;
  padding-left: 10px;
  flex-grow: 1;
}
.rate {
  color: #ffffff;
  width: 100px;
  padding-right: 20px;
  text-align: right;
}
.no-data {
  background: url('~@/assets/images/RiskMonitoring/nodata4.png') no-repeat top 50px center;
  padding-top: 176px;
  font-size: 24px;
  color: #5f98a2;
  text-align: center;
}
</style>

<style lang="scss">
.enterp-ellipsis {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.warn-compnay-map {
  background: url('~@/assets/images/RiskMonitoring/comp-icon.png') no-repeat;
  width: 125px;
  height: 154px;
  text-align: center;
  position: relative;
  left: -23px;
}
.warn-compnay-map-0 {
  background: url('~@/assets/images/RiskMonitoring/comp-icon-1.png') no-repeat;
}
.warn-compnay-map:hover {
  z-index: 10;
}
</style>

<style lang="scss" scoped>
@media screen and (min-width: 1900px) {
  .view-panel {
    height: 376px;
  }
  .compnay {
    font-size: 20px;
  }
  .rank {
    width: 56px;
    font-size: 22px;
  }
}

@media screen and (min-width: 1600px) and (max-width: 1899px) {
  .view-panel {
    width: 383px;
    height: 313px;
  }
  .compnay {
    font-size: 14px;
  }
  .rank {
    width: 49px;
    font-size: 20px;
  }
  .no-data {
    padding-top: 178px;
    background-position: center center;
    font-size: 16px;
    background-size: auto 58%;
  }
}

@media screen and (max-width: 1599px) {
  .view-panel {
    width: 306px;
    height: 250px;
  }
  .compnay {
    font-size: 12px;
  }
  .compnay-item {
    height: 28px;
    line-height: 28px;
    padding-top: 2px;
  }
  .rank {
    width: 39px;
    font-size: 14px;
  }
  .rate {
    font-size: 12px;
  }
  .no-data {
    padding-top: 117px;
    background-position: center center;
    font-size: 14px;
    background-size: auto 60%;
  }
}
</style>
